import React from 'react';
const WhyDataEngineering = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                           Why Data Engineering & Foundations?
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Modern AI and analytics initiatives depend on robust data engineering foundations - yet many organizations remain stuck with legacy systems and disconnected silos. As data volumes and velocity grow, brittle pipelines and manual processes slow progress. Cloud-native, automated architectures are the answer, but migration complexity and talent gaps make scaling difficult.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-4 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Businesses often face data trapped in disparate systems, slow ETL processes prone to errors, and poor-quality data leading to costly decisions. Real-time data capabilities remain out of reach, while maintaining on-premise infrastructure adds unnecessary costs. Without governance or alignment, compliance and AI adoption both suffer.
                        </p>
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            That&apos;s where we help. Whether migrating legacy warehouses to Snowflake for 10x efficiency, engineering fraud-detection pipelines with streaming data, consolidating dozens of sources into a unified data lake, or automating transformation workflows that cut manual effort by over 70%. Our approach lays the groundwork for enterprise AI readiness, business-aligned strategy, and intelligent decision-making.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyDataEngineering;
